module.exports = __webpack_public_path__ + "img/logo.00ce5342.png";